
import { RealityCapturePoint } from '@typings/reality-capture/common';
import { getRasterImage, getWindowFromBBox, rasterToPoints, uuidtoUrl } from './utils/dem-utils';
import { areaToBbox } from './utils/common';
import { FileTreeService } from '@shared/services/FileTreeService';



export class DemStore {
    private sourcePairs: { uuid: string; url: string }[] = [];
    private treeData: any = null;
    private tileLayers: any = null;

    constructor() {
        FileTreeService.fetchFileTree().then(data => {
            this.treeData = data;
        });
    }

    addSource(uuid: string) {
        const sourceUrl = uuidtoUrl(uuid);
        this.sourcePairs.push({ uuid, url: sourceUrl });
    }

    setTileLayers(tileLayers: any) {
        this.tileLayers = tileLayers;
    }

    clearSources() {
        this.sourcePairs = [];
    }
    
    getActiveDemFileUuids(): string[] {
        console.log("getDemFileUuids", this.tileLayers);
        return this.tileLayers?.layersDefinitions
            ?.filter(l => !!l?.demUrl && l?.activeUuids?.length)
            ?.flatMap(l => l.activeUuids) || [];
    }

    getFileNameFromUuid(uuid: string): string {
        const file = FileTreeService.findNodeByUuid(this.treeData, uuid);
        return file.name;
    }

    async getPointsInsideRegion(region: number[][]): Promise<RealityCapturePoint[]> {
        const bbox = areaToBbox(region);
        
        const pointsArrays = await Promise.all(
            this.sourcePairs.map(async ({ uuid, url }, index) => {
                try {
                    // Get the raster image
                    const image = await getRasterImage(url);

                    // Calculate window to read
                    const window = getWindowFromBBox(image, bbox);

                    // Read only the raster from bbox
                    const rasters = await image.readRasters({ window });

                    // Convert raster data to points
                    const fileName = this.getFileNameFromUuid(uuid);
                    const points = await rasterToPoints(fileName, rasters, image, window, index);

                    return points;
                } catch (error) {
                    console.error(`Failed to fetch points from source ${url}:`, error);
                    return [];
                }
            })
        );
        // Return merged points
        return pointsArrays.flat();
    }
}

export const demStore = new DemStore();
